var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import { Caption } from "@irati/ui/src/Labels";
import { connect } from "@irati/store";
import { Container, Bullet, Pipe } from "./styled/Item";
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Item.prototype.render = function () {
        var _a = this.props, isPhone = _a.isPhone, text = _a.text, isFirstItem = _a.isFirstItem;
        return (React.createElement(Container, null,
            !isFirstItem && (isPhone ? React.createElement(Bullet, null, "\u2022") : React.createElement(Pipe, null)),
            React.createElement(Caption, { flush: true }, text)));
    };
    Item.defaultProps = {
        isFirstItem: false
    };
    return Item;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isPhone: get(mq, "lessThan.medium", false)
    });
};
export default connect(mapStateToProps)(Item);
